const LangSidebar = {
	"sidebar.navigation._account": ["ACCOUNT SUMMARY", "TÓM TẮT TÀI KHOẢN"],
	"sidebar.navigation._rewards": ["MY VOUCHERS", "QUÀ THƯỞNG CỦA TÔI"],
	"sidebar.navigation._profile": ["MY PROFILE", "TÀI KHOẢN CỦA TÔI"],
	"sidebar.navigation._cards": ["MY CARDS", "THẺ CỦA TÔI"],
	"sidebar.navigation._transactions": ["MY HISTORY", "LỊCH SỬ GIAO DỊCH"],
	"sidebar.navigation._contactUs": ["CONTACT US", "LIÊN HỆ CHÚNG TÔI NGAY"],
	"sidebar.navigation._aboutUs": ["ABOUT US", "LIÊN HỆ"],
	"sidebar.navigation._activateCard": ["ACTIVATE CARD", "ACTIVATE CARD"],
	"sidebar.navigation._changePassword": ["CHANGE PASSWORD", "CHANGE PASSWORD"],
	"sidebar.navigation._logout": ["LOG OUT", "ĐĂNG XUẤT"],
	"sidebar.navigation._unregister": ["UNREGISTER", "HỦY TÀI KHOẢN"],
	"sidebar.navigation._downloadMobile": [
		"Download Mobile App",
		"TẢI ỨNG DỤNG ĐIỆN THOẠI",
	],
	"sidebar.navigation._havingDifficulties": [
		"HAVING DIFFICULTIES? ",
		"BẠN CẦN GIÚP ĐỠ?",
	],
	"sidebar.navigation._contact": ["CONTACT", "LIÊN HỆ"],
	"sidebar.navigation._contactCsv": ["OUR CUSTOMER SERIVCE NOW", "CHÚNG TÔI NGAY"],
}

export default LangSidebar



// WEBPACK FOOTER //
// ./src/resources/modules/LangSidebar.js